import { useNavigate } from "react-router-dom";
import { ChevronLeft, MessageCircle, Clock, CreditCard, Truck, RotateCcw } from "lucide-react";

const WA_CS = "6281234567890"; // nomor WA CS Kiyana — ganti dengan nomor asli

export default function StoreHelp() {
  const nav = useNavigate();
  return (
    <div className="space-y-4 animate-fade-up">
      <div className="flex items-center justify-between">
        <button onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-white border border-blush-soft flex items-center justify-center">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h1 className="font-semibold">Bantuan & CS</h1>
        <div className="w-9" />
      </div>

      <a
        data-testid="wa-cs-btn"
        href={`https://wa.me/${WA_CS}?text=${encodeURIComponent("Halo Kiyana, saya butuh bantuan 😊")}`}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-3 bg-emerald-500 text-white rounded-2xl p-4"
      >
        <div className="w-11 h-11 bg-white/20 rounded-xl flex items-center justify-center">
          <MessageCircle className="w-6 h-6" />
        </div>
        <div>
          <div className="font-semibold text-sm">Chat WhatsApp CS</div>
          <div className="text-xs opacity-90">Respon cepat, setiap hari 08.00–21.00 WIB</div>
        </div>
      </a>

      <div className="bg-white rounded-2xl border border-blush-soft p-4">
        <div className="text-sm font-semibold mb-3 flex items-center gap-2"><Clock className="w-4 h-4 text-brand" /> Pertanyaan Umum</div>
        {[
          { q: "Bagaimana cara membayar pesanan?", a: "Pilih Transfer Bank (BCA/Mandiri) atau QRIS saat checkout, lalu unggah bukti pembayaran di halaman detail pesanan. Admin akan verifikasi maks. 1x24 jam." },
          { q: "Berapa lama pengiriman?", a: "Reguler 2-4 hari kerja, Express 1-2 hari kerja. Gratis ongkir untuk belanja minimal Rp150.000 (reguler)." },
          { q: "Bagaimana cara retur?", a: "Buka detail pesanan berstatus Dikirim/Selesai, tekan 'Ajukan Retur / Refund', isi alasannya. CS akan menghubungi via WhatsApp." },
          { q: "Bagaimana cara pakai voucher?", a: "Salin kode di halaman Voucher Saya, lalu masukkan di kolom voucher saat checkout sebelum bayar." },
        ].map((f, i) => (
          <details key={i} className="border-b border-blush-soft last:border-0 py-2.5">
            <summary className="text-xs font-medium cursor-pointer list-none flex justify-between items-center">{f.q}<span className="text-brand">+</span></summary>
            <p className="text-xs text-cocoa-muted mt-1.5 leading-relaxed">{f.a}</p>
          </details>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="bg-white rounded-2xl border border-blush-soft p-4">
          <CreditCard className="w-5 h-5 text-brand mb-2" />
          <div className="text-xs font-semibold">Metode Pembayaran</div>
          <div className="text-[11px] text-cocoa-muted mt-1 leading-relaxed">Transfer BCA 8830123456, Mandiri 1400099887766, QRIS Kiyana, VA (Xendit).</div>
        </div>
        <div className="bg-white rounded-2xl border border-blush-soft p-4">
          <Truck className="w-5 h-5 text-brand mb-2" />
          <div className="text-xs font-semibold">Pengiriman</div>
          <div className="text-[11px] text-cocoa-muted mt-1 leading-relaxed">JNE (OKE/Reguler/YES) & SPX (Hemat/Reguler) dari Kota Cirebon ke seluruh Indonesia, lengkap dengan tracking resi. Packing aman & higienis.</div>
        </div>
      </div>

      <div className="bg-blush rounded-2xl p-4 flex gap-3">
        <RotateCcw className="w-5 h-5 text-brand flex-shrink-0" />
        <div className="text-xs text-cocoa leading-relaxed">
          <b>Kebijakan Retur:</b> maks. 3 hari setelah pesanan diterima, produk belum dicuci/dipakai, label masih terpasang. Ongkir retur ditanggung Kiyana jika kesalahan dari kami.
        </div>
      </div>
    </div>
  );
}
